import register from 'preact-custom-element'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { useEffect, useState, useRef } from 'preact/hooks'
import { getCart } from 'libs/cart'
import { fetchRecommendedProductById } from 'libs/shopify-product'
import { normalizeProducts } from 'libs/shopify-normalize'
import ProductCarousel from 'snippets/product/product-carousel/product-carousel'
import LoaderSpin from 'snippets/loader-spin/loader-spin'

const selectors = {
  limit: 8
}

function ProductRecommended(props) {
  const elRef = useRef(null)
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const getRecommendedProducts = async (id) => {
    const recommendations = await fetchRecommendedProductById(id)

    if (recommendations && recommendations.length > 0) {
      return normalizeProducts(recommendations, 'shopify-graphql-recommendations').splice(0, selectors.limit)
    }

    return []
  }

  const options = {
    slidesPerView: 1,
    spaceBetween: 8,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      768: {
        slidesPerView: 3
      }
    }
  }

  const init = async (id) => {
    if (!id) {
      setIsLoading(false)
      throw new Error('Related product must have product id')
    }

    try {
      setIsLoading(true)

      const items = await getRecommendedProducts(id)
      const cartData = await getCart()
      const productData = items.filter(product => !cartData.items?.some(item => item.handle === product.handle))

      setProducts(productData.length > 0 ? productData : [])
    } catch (error) {
      setIsLoading(false)
      throw new Error('Error to fetch product related')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    globalEmitter.on(emitterProps.cart.add, async (cartData) => {
      init(cartData.data.items[0].product_id)
    })
  }, [])

  return (
    <div className="transition-all pt-5 md:pt-6">
      <div className="relative" ref={elRef}>
        {isLoading ? (
          <div className="flex h-96 w-full items-center justify-center">
            <LoaderSpin size="8" />
          </div>
        ) : (
          products.length > 0 && (
            <div className="w-full">
              <ProductCarousel className="carousel-product-recommended" options={options} products={products} title={props.heading} selector="js-product-recommended-carousel" />
            </div>
          )
        )}
      </div>
    </div>
  )
}

if (!customElements.get('product-recommended')) {
  register(ProductRecommended, 'product-recommended')
}
